import Chart from 'chart.js/auto';
import 'chartjs-adapter-moment';

const organizationDashboardAttendanceGraphs = (lazyLoadedElement) => {
  const { tab } = lazyLoadedElement.dataset;
  let i;

  if (tab === 'overview') {
    // Overview charts
    const attendanceTrendsChart = document.getElementById('attendance-thirty-trends');
    const attendanceDataDiv = document.getElementById('attendance-thirty-data');
    if (attendanceDataDiv) {
      if (!Chart.getChart(attendanceTrendsChart)) {
        const attendanceData = JSON.parse(attendanceDataDiv.dataset.attrs);
        const attendanceTrends = new Chart(attendanceTrendsChart, {
          type: 'bar',
          data: attendanceData,
          options: {
            scales: {
              x: {
                stacked: true,
                type: 'time',
                time: {
                  parser: 'YYYY-MM-DD',
                  tooltipFormat: 'll',
                  unit: 'day',
                  displayFormats: {
                    millisecond: 'MM/DD/YYYY',
                    second: 'MM/DD/YYYY',
                    minute: 'MM/DD/YYYY',
                    hour: 'MM/DD/YYYY',
                    day: 'MM/DD/YYYY',
                    week: 'MM/DD/YYYY',
                    month: 'MM/DD/YYYY',
                    quarter: 'MM/DD/YYYY',
                    year: 'MM/DD/YYYY',
                  },
                },
                ticks: {
                  autoSkip: true,
                  maxTicksLimit: 20,
                },
              },
              y: {
                stacked: true,
                beginAtZero: true,
                ticks: {
                  stepSize: 1,
                  precision: 0,
                },
                title: {
                  display: true,
                  text: 'Number of sessions',
                  font: {
                    size: 16,
                  },
                },
              },
            },
            plugins: {
              legend: {
                position: 'top',
              },
              title: {
                display: true,
                text: 'Attendance over the past 30 days',
                font: {
                  size: 24,
                },
              },
            },
          },
        });

        // we want to allow the canvas to finish rendering before we get the base 64 image
        setTimeout(() => {
          const printCanvasValue = document.getElementById('overview_bar_data');
          printCanvasValue.value = `${attendanceTrendsChart.toDataURL('image/png')}`;
        }, 500);
      }
    }

    const attendanceEntireTrendsChart = document.getElementById('attendance-entire-trends');
    const attendanceEntireDataDiv = document.getElementById('attendance-entire-data');
    if (attendanceEntireDataDiv) {
      if (!Chart.getChart(attendanceEntireTrendsChart)) {
        const attendanceEntireData = JSON.parse(attendanceEntireDataDiv.dataset.attrs);
        const attendanceEntireLabels = [];
        const attendanceEntireDataTotal = [];

        for (i = 0; i < attendanceEntireData.length; i += 1) {
          const data = attendanceEntireData[i];
          attendanceEntireLabels.push(data[0]);
          attendanceEntireDataTotal.push(data[1]);
        }

        const attendanceEntireTrends = new Chart(attendanceEntireTrendsChart, {
          type: 'pie',
          data: attendanceEntireData,
          options: {
            responsive: true,
            maintainAspectRatio: false,
            layout: {
              padding: {
                top: 0,
                right: 20,
                bottom: 20,
                left: 20,
              },
            },
            plugins: {
              legend: {
                position: 'top',
              },
              title: {
                display: true,
                text: 'Attendance over the history of the organization',
                font: {
                  size: 24,
                },
              },
            },
          },
        });

        // we want to allow the canvas to finish rendering before we get the base 64 image
        setTimeout(() => {
          const printCanvasValue = document.getElementById('overview_pie_data');
          printCanvasValue.value = `${attendanceEntireTrendsChart.toDataURL('image/png')}`;
        }, 500);
      }
    }

    return;
  }

  const rateattendanceTypeTrendsChart = document.getElementById(`rate-attendance-type-trends`);
  const rateattendanceTypeDataDiv = document.getElementById(`rate-attendance-type-data`);
  if (rateattendanceTypeDataDiv) {
    if (!Chart.getChart(rateattendanceTypeTrendsChart)) {
      const rateattendanceTypeData = JSON.parse(rateattendanceTypeDataDiv.dataset.attrs);
      const chartTile = rateattendanceTypeDataDiv.dataset.title;
      const yAxisTitle = rateattendanceTypeData.y_axis_label;
      const displayLegend = rateattendanceTypeData.datasets.length > 1;

      const attendanceTypeTrends = new Chart(rateattendanceTypeTrendsChart, {
        type: 'line',
        data: rateattendanceTypeData,
        options: {
          responsive: true,
          plugins: {
            legend: {
              display: displayLegend,
              position: 'top',
            },
            title: {
              display: true,
              text: chartTile,
              font: {
                size: 24,
              },
            },
          },
          scales: {
            x: {
              type: 'time',
              time: {
                parser: 'YYYY-MM-DD',
                tooltipFormat: 'll',
                unit: 'day',
                displayFormats: {
                  millisecond: 'MM/DD/YYYY',
                  second: 'MM/DD/YYYY',
                  minute: 'MM/DD/YYYY',
                  hour: 'MM/DD/YYYY',
                  day: 'MM/DD/YYYY',
                  week: 'MM/DD/YYYY',
                  month: 'MM/DD/YYYY',
                  quarter: 'MM/DD/YYYY',
                  year: 'MM/DD/YYYY',
                },
              },
              ticks: {
                autoSkip: true,
                maxTicksLimit: 20,
              },
            },
            y: {
              beginAtZero: true,
              min: 0,
              max: 100,
              ticks: {
                stepSize: 10,
                precision: 0,
              },
              title: {
                display: true,
                text: yAxisTitle,
                font: {
                  size: 16,
                },
              },
            },
          },
        },
      });

      // we want to allow the canvas to finish rendering before we get the base 64 image
      setTimeout(() => {
        const printCanvasValue = document.getElementById(`present_canvas_image_data`);
        printCanvasValue.value = `${rateattendanceTypeTrendsChart.toDataURL('image/png')}`;
      }, 500);
    }
  }

  // all other chart tabs
  const attendanceTypeTrendsChart = document.getElementById(`${tab}-attendance-type-trends`);
  const attendanceTypeDataDiv = document.getElementById(`${tab}-attendance-type-data`);
  if (attendanceTypeDataDiv) {
    if (!Chart.getChart(attendanceTypeTrendsChart)) {
      const attendanceTypeData = JSON.parse(attendanceTypeDataDiv.dataset.attrs);
      const chartTile = attendanceTypeDataDiv.dataset.title;
      const yAxisTitle = attendanceTypeData.y_axis_label;
      const displayLegend = attendanceTypeData.datasets.length > 1;

      const attendanceTypeTrends = new Chart(attendanceTypeTrendsChart, {
        type: 'line',
        data: attendanceTypeData,
        options: {
          responsive: true,
          plugins: {
            legend: {
              display: displayLegend,
              position: 'top',
            },
            title: {
              display: true,
              text: chartTile,
              font: {
                size: 24,
              },
            },
          },
          scales: {
            x: {
              type: 'time',
              time: {
                parser: 'YYYY-MM-DD',
                tooltipFormat: 'll',
                unit: 'day',
                displayFormats: {
                  millisecond: 'MM/DD/YYYY',
                  second: 'MM/DD/YYYY',
                  minute: 'MM/DD/YYYY',
                  hour: 'MM/DD/YYYY',
                  day: 'MM/DD/YYYY',
                  week: 'MM/DD/YYYY',
                  month: 'MM/DD/YYYY',
                  quarter: 'MM/DD/YYYY',
                  year: 'MM/DD/YYYY',
                },
              },
              ticks: {
                autoSkip: true,
                maxTicksLimit: 20,
              },
            },
            y: {
              beginAtZero: true,
              ticks: {
                stepSize: 1,
                precision: 0,
              },
              title: {
                display: true,
                text: yAxisTitle,
                font: {
                  size: 16,
                },
              },
            },
          },
        },
      });

      // we want to allow the canvas to finish rendering before we get the base 64 image
      setTimeout(() => {
        const printCanvasValue = document.getElementById(`${tab}_canvas_image_data`);
        printCanvasValue.value = `${attendanceTypeTrendsChart.toDataURL('image/png')}`;
      }, 500);
    }
  }
};

export default organizationDashboardAttendanceGraphs;
